// extracted by mini-css-extract-plugin
export default {"tupacGrid":"um-z","tupacHeader":"vm-z","tupacHeader2":"wm-z","tupacMenu":"xm-z","tupacMenu2":"ym-z","tupacMain":"zm-z","tupacMain2":"Am-z"};